import React from 'react';
import { FILTER } from '@fiverr-private/listing_lib';
import { getContext } from '@fiverr-private/fiverr_context';
import { NewBadge } from '@fiverr-private/badges';
import Toggle from '../toggle';
import { usePersonalAssistantRolloutEnabled } from '../../../../../../../hooks/rollouts/usePersonalAssistantRolloutEnabled';
import { PersonalAssistantToggleProps } from './PersonalAssistantToggle.types';

export const PersonalAssistantToggle = ({ filter, ...rest }: PersonalAssistantToggleProps) => {
    const { isMobile } = getContext();

    const isPersonalAssistantRolloutEnabled = usePersonalAssistantRolloutEnabled();

    if (!filter || !isPersonalAssistantRolloutEnabled) return null;

    return (
        <Toggle
            selectedValue={FILTER.PERSONAL_ASSISTANT.SELECTED_VALUE}
            title={'search_perseus.filters.global.personal_assistant.alias'}
            text={'search_perseus.filters.global.personal_assistant.text'}
            badge={isMobile ? null : <NewBadge />}
            shouldBeAIToggle={true}
            {...filter}
            {...rest}
        />
    );
};
